export const cloudflareTurnstileService = {
    submitFormWithChallenge: (form, submitCallback = null, isFlexible = false) => {
        if (window.turnstile_disabled) {
            // On BE side `cf-turnstile-response` parameter is required.
            // Input with non-empty value needs to be added for autotests to work correctly
            if (! $(form).find('input[name="cf-turnstile-response"]').length) {
                $('<input>').attr({
                    type: 'hidden',
                    name: 'cf-turnstile-response',
                    value: 'Cloudflare Turnstile disabled'
                }).appendTo(form);
            }

            submitCallback ? submitCallback() : form.submit();

            return;
        }

        const widgetContainer = form.find('.js_cf-turnstile-container')[0];

        // Prevent repeated form submission attempts
        // until customer passes displayed turnstile widget
        if (widgetContainer.children.length) return;

        turnstile.render(widgetContainer, {
            sitekey: window.env.turnstileSiteKey,
            appearance: window.env.turnstileAppearance,
            callback: submitCallback || ((token) => form.submit()),
            "error-callback": (errorCode) => turnstile.reset(widgetContainer),
            theme: "light",
            size: isFlexible ? "flexible" : "normal",
        });
    },

    clearTurnstileContainer: () => {
        if (! window.turnstile_disabled) {
            turnstile.remove();
        }
    },
}
